import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IHttpData, STATUS } from '../../common/use-loading.model';
import { EoDropdownComponent } from '../eo-dropdown/eo-dropdown.component';
import { EoPrefectureDropdownConfig } from './eo-prefecture-dropdown.model';
import { EoPrefectureDropdownService } from './eo-prefecture-dropdown.service';
import { Prefecture } from './prefecture.model';

@Component({
  selector: 'eo-prefecture-dropdown',
  templateUrl: './eo-prefecture-dropdown.component.html',
  styleUrl: './eo-prefecture-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoPrefectureDropdownComponent),
      multi: true,
    },
  ],
})
export class EoPrefectureDropdownComponent
  extends EoDropdownComponent<Prefecture>
  implements OnInit, IHttpData<Prefecture[]>
{
  @Input() override label = 'Νομός';
  @Input() url?: string;

  @Input() override set config(val: EoPrefectureDropdownConfig | undefined) {
    super.config = val;
  }

  override get config(): EoPrefectureDropdownConfig | undefined {
    return super.config;
  }

  override httpData$ = this.prefectureService.data$;
  override httpStatus$ = this.prefectureService.status$;
  override httpError$ = this.prefectureService.error$;

  override fetchData(): void {
    this.prefectureService.getPrefectures(this.getUrl()).subscribe();
  }

  constructor(private prefectureService: EoPrefectureDropdownService) {
    super();
  }

  override ngOnInit(): void {
    this.fetchData();
    this.subscriptions = [...this.subscriptions, this.onHttpStatusChange()];
  }

  onHttpStatusChange() {
    return this.httpStatus$.subscribe((status) => {
      switch (status) {
        case STATUS.loading:
          this.loading = true;
          break;
        default:
          this.loading = false;
      }
    });
  }

  getUrl(): string {
    return (
      this.url ??
      (this.config as EoPrefectureDropdownConfig)?.url ??
      'v1/Prefectures/list'
    );
  }
}
